import { BACKGROUNDS_URL } from 'src/config/Endpoints/Endpoints';

export const DEFAULT_BACKGROUND: string = `${BACKGROUNDS_URL}/default-background.jpg`;
export const HOME_FOOTER: string = `${BACKGROUNDS_URL}/home-footer.jpg`;
export const STORE_BACKGROUND: string = `${BACKGROUNDS_URL}/store-background.jpg`;
export const AUTH_BANNER: string = `${BACKGROUNDS_URL}/auth-banner.jpg`;
